import { useSignIn } from "../../../hooks/useSignIn";
import InputField from "components/fields/InputField";
import Default from "layouts/auth/types/Default";
import { useTranslation } from "react-i18next";

function SignInDefault() {
  const { t } = useTranslation();
  const {
    email,
    setEmail,
    password,
    setPassword,
    error,
    isLoading,
    handleSignIn,
    handleKeyPress,
  } = useSignIn();

  return (
    <Default
      maincard={
        <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
          <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
            <h3 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
              {t("auth.signIn")}
            </h3>
            <p className="mb-9 ml-1 text-base text-gray-600">
              {t("auth.enterEmailPassword")}
            </p>

            {/* Email */}
            <InputField
              variant="auth"
              extra="mb-3"
              label={t("auth.emailRequired")}
              placeholder={t("auth.emailPlaceholder")}
              id="email"
              type="text"
              value={email}
              onChange={(e: any) => setEmail(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={isLoading}
            />

            {/* Password */}
            <InputField
              variant="auth"
              extra="mb-3"
              label={t("auth.passwordRequired")}
              placeholder={t("auth.passwordPlaceholder")}
              id="password"
              type="password"
              value={password}
              onChange={(e: any) => setPassword(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={isLoading}
            />

            {error && (
              <p className="mb-4 text-sm font-medium text-red-500">{error}</p>
            )}

            <button
              onClick={handleSignIn}
              disabled={isLoading}
              className="linear w-full rounded-xl bg-brand-500 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
            >
              {isLoading ? t("auth.signingIn") : t("auth.signIn")}
            </button>
          </div>
        </div>
      }
    />
  );
}

export default SignInDefault;
